import { integration } from '../integration';
import { store } from '../stores/mainStore';

export class HTTPServer {
	constructor(server) {
		this.server = server;
		this.mode = 'production';
		this.failMode = 'first';
		this.qa = {};
	}

	SetDebugMode(mode, failMode) {
		this.mode = mode;
		this.failMode = failMode;
	}

	//TODO: refactor retryCount, which is named poorly since it is used to allow retires to be avoided by setting -1 and setting it to a positive number will not have the expected result
	CallRoute(route, payload, method = 'POST', retryCount = 0) {
		// window.manager.logWrapperMsg("calling ROUTE "+route);
		return new Promise((resolve, reject) => {
			//console.log("6214 CallRoute: "+route, 'tok =', this.token);

			const call = (retryCount) => {
				//Call a structured route
				let request = { method,
					Route: route,
					Payload: payload,
				};
				if(route === 'mini-game-3')		
					store.slowNet(true);
				else if(!route.includes('balance'))						
					store.setSpinner(true)

				return this.SendPacket(request)
					.then((response) => {
						console.log('6214 <--- packet', route, 'RESPONSE', response)
						store.setSpinner(false);
						//if(route !== 'mini-game-3')
							store.slowNet(false)

						if(response.error) {
							integration.postMixPanelEvent("server_error_shown");
							store.errorMessage = response;
							reject(response.error)
						}
						return resolve(response);
					})
					.catch((err) => {
						if (retryCount === -1) {
							//Do not retry. It is ok to fail.
							if(route === 'confirm-email')
								return resolve(err)
						} else {
							if (!retryCount || retryCount < 5) {
								console.warn(`Will Retry (${retryCount + 1})`, err);
								retryCount += 1;
								setTimeout(() => {
									store.setSpinner(false);
									call(retryCount);
								}, 750 * retryCount);
							} else {
								integration.onError(`Server communication failed at route: ${route}`);
								integration.postMixPanelEvent("server_error_shown");
								store.errorMessage = `Server communication failed at route: ${route} ${JSON.stringify(err)}`;
								reject(`route "${route}" failed ${retryCount} times. Could not complete server request.`);
							}
						}
					});
			}; // end call

			call(retryCount || 0);
		});
	}

	SendPacket(packet) {
		if (this.mode === 'qa') {
			let route = packet.Route;
			if (!this.qa[route]) {
				this.qa[route] = 0;
			}
			if (this.failMode === 'first') {
				if (this.qa[route] !== 0) {
					this.qa[route] = 0;
				} else {
					++this.qa[route];
					return new Promise(function (resolve, reject) {
						reject({
							errorCode: 1,
							errorMessage: 'Could not complete server request. First Fail',
						});
					});
				}
			}
		}

		const req = {
			method: packet.method,
			headers: {
				'Authorization': 'Bearer b970869b-4f4d-4046-8b7b-bbceb3a30ac3',
				'Content-Type': 'application/json'
			},
		}
		if(this.accessToken)			req.headers['X-Auth-Token'] = 'Bearer ' + this.accessToken;
		if(packet.method === 'POST')	req.body = JSON.stringify(packet.Payload)
		console.log('6214 ---> REQ =', packet.Route, req)
	
		return fetch(this.server + '/client/' + packet.Route, req).then((response) => {
			return response.json().then((data) => {
				if (data && data.accessToken) {
					this.accessToken = data.accessToken;
				}
				return data;
			});
		});
	}
}
